import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "../../rootReducer";

export const selectDocumentTypesAvailable = createSelector(
    [
        (store: RootState) => store.massNotification.documentTypesList,
        (store: RootState) => store.massNotification.selectedDocumentTypes,
    ],
    (documentTypesList, selectedDocumentTypes) => {
        const data = documentTypesList?.filter(
        ({ id }) => {

            // Descarta tipos de documentos que ya están seleccionados o asignados
            if (selectedDocumentTypes.find(( { id: selectedDocumentTypeId }) => selectedDocumentTypeId === id)) {
                return false;
              }
            return true;
        })

        const orderedList = [...data].sort((a, b) => {
            if (a.name && b.name && a.name < b.name) {
              return -1;
            }
            if (a.name && b.name && a.name > b.name) {
              return 1;
            }
            return 0;
          });
      
        return orderedList;
    }
);